import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Observable } from "rxjs";
import { environment } from "../../environments/environment";

@Injectable({
  providedIn: "root",
})
export class VehicleRolloutService {
  constructor(private readonly http: HttpClient) {}

  getVehicleReportRolloutMenuOptions(): Observable<any> {
    const url = environment.serviceURL + "/vehicleRolloutReportMenuItems";
    return this.http.get<any>(url);
  }

  getVehicleReportRolloutData(
    year: string,
    oem: any[],
    brand: any[],
    segment: any[],
    bodyStyle: any[],
    regions: any[]
  ): Observable<any> {
    const url = environment.serviceURL + "/vehicleRolloutReportData";
    return this.http.post<any>(url, {
      year,
      regions,
      oem,
      brand,
      bodyStyle,
      segment,
    });
  }

  exportToExcel(
    year: string,
    oem: any[],
    brand: any[],
    segment: any[],
    bodyStyle: any[],
    regions: any[]
  ): Observable<any> {
    const url = environment.serviceURL + "/vehicleRolloutReportExportToExcel";
    const headers = new HttpHeaders();
    headers["Content-Disposition"] = "attachment; filename=filename.pdf";
    return this.http.post(
      url,
      { year, oem, brand, segment, bodyStyle, regions },
      { headers, responseType: "blob" }
    );
  }
}
